import { keyframes, styled, css } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
"use strict";
const animationMs = 400;
const animationSlideUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
`;
const Wrap = styled.div`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  width: 100%;
  height: 100%;
  opacity: 1;
  top: 0;
  left: 0;
  overflow: hidden;
  display: none;

  ${({
  $isOpen
}) => $isOpen && css`
      display: block;
    `}
`;
const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: rgb(255 255 255 / 0.7);
`;
const InnerWrap = styled.div`
  background: ${theme.colors.white};
  box-shadow: 0 -4px 15px rgb(0 0 0 / 0.15);

  position: absolute;
  left: 0;
  /* In WebView context we need to respect the bottom inset area of mobile device. */
  /* It falls back to 0px on web clients that doesn't support safe area inset */
  bottom: env(safe-area-inset-bottom);
  width: 100%;
  transform: translateY(100%);
  will-change: transform;

  ${({
  $isOpen
}) => $isOpen && css`
      animation: ${animationSlideUp} ${animationMs}ms ease-in-out forwards;
      animation-iteration-count: 1;
    `}
`;
const TopCloseWrap = styled.div`
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.waterloo};
`;
const BottomCloseWrap = styled.div`
  padding: 30px 15px 15px;
`;
const ContentWrap = styled.div`
  padding: 0 15px;
  margin: 15px auto 0;
  max-height: 60vh;
  overflow-y: auto;
`;
export { BottomCloseWrap, ContentWrap, InnerWrap, Overlay, TopCloseWrap, Wrap };
//# sourceMappingURL=MobileModal.styles.mjs.map
